import React, { useCallback } from 'react';
import { COLORS, Icon } from '@livecommerce/design-system';
import { styled } from '@linaria/react';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import HeaderItem from './HeaderItem.jsx';
import { useAiAssistant } from 'components-v3/AIChatBot/index.js';

const HeaderItemContents = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
`;

const AIChatBotHeaderItem = () => {
  const { t } = useLocalization();
  const { isInitialized, isOpen, open, close } = useAiAssistant();

  const onClick = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);

  if (!isInitialized) {
    return null;
  }

  return (
    <HeaderItem
      label={t('aiAssistant.title')}
      onClick={onClick}
      id="ai-chatbot-button"
    >
      <HeaderItemContents>
        <Icon name="ai" color={COLORS.orange_500} />
      </HeaderItemContents>
    </HeaderItem>
  );
};

export default AIChatBotHeaderItem;
